/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InspectionSyncDetailsRequest
 */
export interface InspectionSyncDetailsRequest {
    /**
     * 
     * @type {Date}
     * @memberof InspectionSyncDetailsRequest
     */
    lastSyncDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof InspectionSyncDetailsRequest
     */
    payloadVersion?: number | null;
}

/**
 * Check if a given object implements the InspectionSyncDetailsRequest interface.
 */
export function instanceOfInspectionSyncDetailsRequest(value: object): value is InspectionSyncDetailsRequest {
    return true;
}

export function InspectionSyncDetailsRequestFromJSON(json: any): InspectionSyncDetailsRequest {
    return InspectionSyncDetailsRequestFromJSONTyped(json, false);
}

export function InspectionSyncDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionSyncDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lastSyncDate': json['lastSyncDate'] == null ? undefined : (new Date(json['lastSyncDate'])),
        'payloadVersion': json['payloadVersion'] == null ? undefined : json['payloadVersion'],
    };
}

export function InspectionSyncDetailsRequestToJSON(json: any): InspectionSyncDetailsRequest {
    return InspectionSyncDetailsRequestToJSONTyped(json, false);
}

export function InspectionSyncDetailsRequestToJSONTyped(value?: InspectionSyncDetailsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastSyncDate': value['lastSyncDate'] === null ? null : ((value['lastSyncDate'] as any)?.toISOString()),
        'payloadVersion': value['payloadVersion'],
    };
}

